<template>
    <div class="trophy-overview card card-shadow">
        <div class="flex flex-full-height">
            <div class="user-overview card-inner relative">
                <div class="top">
                    <div class="profile-icon-m float-left">
                        <img :src="user.avatar">
                    </div>
                    <div class="inline-block">
                        <p class="profile-name">{{ user.first_name }} {{ user.last_name }}</p>
                        <div class="small-title-text">
                            <i class="fa fa-trophy"></i>
                            <span class="bold-text" v-text="user.karma"></span>
                        </div>
                    </div>
                </div>
                <div class="content">
                    <p class="normal-text">{{ translations['trophy.trophyroom_welcomeword'] }}!</p>
                </div>
                <div class="bottom absolute">
                    <p class="extra-light-text tiny-text absolute">Trophy {{ translations['trophy.progress'] }} - {{
                            progress
                    }}%</p>
                    <div class="level-progress relative mimic-title">
                        <div class="level-progress-inner absolute secondary-c-bg" :style="{ 'width': progress + '%' }">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	import Global from '../../mixins/Global.js'
	import {mapState} from 'vuex';

	export default {
	    name: 'TrophyOverview',

	    mixins: [Global],

	    computed: {
	        ...mapState([
	            'activeTrophy',
	            'trophiesProgress',
	            'trophies'
	        ]),

	        progress() {
	            let progress = 0;

	            for(var i in this.trophies){
	                progress += this.trophies[i].progress;
	            }

	            // If we have 12 trophies, i = 11 (because we start at 0) so we add one.
	            return Math.round(progress / i + 1);
	        },

	        emptyTrophy() {
	            return {
	                id: 0,
	                background: 'e2e2e2',
	                border: 'd2d2d2',
	                color: '757575',
	                icon: 'fa fa-trophy',
	                title: 'Be a winner',
	                desc: 'Selecteer een behaalde trophy om die bij je profiel te tonen'
	            }
	        },
	    },

	    mounted() {
	        this.$store.dispatch('getAchievements', this.user.id);
	    },
	}
</script>

<style lang="scss">
.trophy-overview {
    height: calc(100% - 20px);

    .trophy-active-badge {
        flex-basis: 174px;
        border-radius: 5px 0 0 5px;

        .trophy-item {
            .hexagon {
                left: -37.887px;
            }
        }

        .trophy-circle {
            max-width: 90px;
        }

        span {
            font-size: 12px;
            line-height: 17px;
        }

        @media(max-width: 576px) {
            padding: 0;
            flex-basis: 100px;
            justify-content: flex-start;
            align-items: flex-start;
            padding-top: 20px;

            .trophy {
                width: 100% !important;

                .trophy-circle {
                    flex-basis: 60px !important;
                    min-width: 60px !important;
                    height: 60px !important;
                    font-size: 20px !important;
                }

                p {
                    display: none !important;
                }
            }
        }
    }

    .user-overview {
        width: calc(100% - 174px);

        .top {
            padding-bottom: 15px;
            margin-bottom: 10px;
            border-bottom: 1px solid #f5f5f5;

            .inline-block {
                padding-left: 15px;
                padding-top: 3px;
            }

            p {
                margin-bottom: 5px;
            }

            i,
            span {
                color: #FFDF00;
                margin-right: 5px;
            }
        }

        .content {
            p {
                width: 70%;
                line-height: 23px;
                margin-bottom: 50px;
            }
        }

        .bottom {
            bottom: 22px;
            width: calc(100% - 44px);

            p {
                bottom: 22px;
            }

            .level-progress {
                height: 12px;
                background: #efefef;
                border-radius: 15px;
                overflow: hidden;

                .level-progress-inner {
                    height: 100%;
                }
            }
        }

        @media(max-width: 576px) {
            width: calc(100% - 100px);

            .content {
                p {
                    width: 100%;
                    font-size: 13px;
                    margin-bottom: 0;
                }
            }

            .bottom {
                position: relative;
                width: 100%;
                bottom: 0;

                .level-progress {
                    height: 10px;
                }

                p {
                    position: relative;
                    bottom: 0;
                    padding-bottom: 12px;
                    margin-top: 20px;
                }
            }
        }
    }

    @media(max-width: 1100px) {
        height: calc(100% - 15px);
    }
}
</style>